import { Calculator, FileText, LucideIcon, MessageSquare, Receipt } from 'lucide-react';

export interface BotDisplayConfig {
  id: string;
  name: string;
  title: string;
  description: string;
  roleLabel: string;
  color: string;
  supportsWebSearch: boolean;
  icon: LucideIcon;
  welcomeMessage: string;
  sampleQueries: string[];
  themeClassName: string;
}

const BOT_CONFIGS: Record<string, BotDisplayConfig> = {
  'finance-report': {
    id: 'finance-report',
    name: 'FINGuide',
    title: 'Financial Research Assistant',
    description: 'Access to the finance report bot',
    roleLabel: 'FinanceReport',
    color: '#a78bfa',
    supportsWebSearch: true,
    icon: FileText,
    welcomeMessage: 'Ask questions about your financial documents and get precise answers.',
    sampleQueries: [
      'What does the current ratio indicate?',
      'Explain the change in debt equity ratio',
      'What are the key financial risks mentioned?',
      'How has operating margin changed year over year?',
    ],
    themeClassName: 'finance-profile',
  },
  'direct-taxation': {
    id: 'direct-taxation',
    name: 'TaxVault',
    title: 'Direct Taxation Assistant',
    description: 'Access to the direct taxation bot',
    roleLabel: 'Taxation',
    color: '#60a5fa',
    supportsWebSearch: false,
    icon: Calculator,
    welcomeMessage: 'Calculate taxes, analyze ITR documents, and get tax compliance guidance.',
    sampleQueries: [

    ],
    themeClassName: 'itr-profile',
  },
  'indirect-taxation': {
    id: 'indirect-taxation',
    name: 'GSTGuide',
    title: 'Indirect Taxation (GST) Assistant',
    description: 'Access to the indirect taxation (GST) bot',
    roleLabel: 'IndirectTaxation',
    color: '#2dd4bf',
    supportsWebSearch: false,
    icon: Receipt,
    welcomeMessage: 'Ask about GST postings in SAP, T-codes, and accounting entries.',
    sampleQueries: [
      'How is a vendor invoice posted in SAP and what are the GST accounting entries?',
      'Which T-code is used to post the vendor invoice?',
      'How is a supplementary invoice or debit note handled?',
      'How is duty deferment under MOOWR bonded warehouse handled?',
    ],
    themeClassName: 'indirect-profile',
  },
};

export function getBotDisplayConfig(botId: string, botName?: string): BotDisplayConfig {
  const existing = BOT_CONFIGS[botId];

  if (existing) {
    return existing;
  }

  return {
    id: botId,
    name: botName || botId,
    title: botName || 'Assistant',
    description: 'Access to the selected bot',
    roleLabel: '',
    color: '#4ade80',
    supportsWebSearch: false,
    icon: MessageSquare,
    welcomeMessage: 'Ask a question to start your conversation.',
    sampleQueries: [],
    themeClassName: 'finance-profile',
  };
}
